import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/api.service';
import { Common } from '../shared/common';
import { ParticipationResponse } from '../models/ParticipationResponse';
import {ReceivedCollege, Round} from '../models/ReceivedPoll';
import { AuthenticationService } from '../shared/authentication.service';
import { environment } from '../../environments/environment';
import { LicenseData } from '../models/LicenseData';
import { LicenseService } from '../shared/licens.service';
import { ShortVoter, VoterVotedResponse } from '../models/ShortVoter';
import { TimeDelta } from '../models/TimeDelta';
import { saveAs } from 'file-saver';
import { Checkup } from '../models/Checkup';
import { SuspendAssessor } from '../models/SuspendAssessor';

@Component({
  selector: 'app-poll-ongoing',
  templateUrl: 'poll-ongoing.component.html',
  styleUrls: ['./poll-ongoing.component.less', '../shared/common.less']
})

export class PollOngoingComponent implements OnInit, OnDestroy {
  candidates: any;
  startDate = '';
  stripe: stripe.Stripe;
  endDate = '';
  pollId: string;
  title: string;
  isOpen: boolean;
  votersCount = 0;
  description = '';
  votes = 0;
  percentage = 0;
  percentageString = '0';
  isError = false;
  isLive = false;
  resolutions: Array<string> = [];
  errorMessage: string;
  isPublic: boolean;
  stripeConstants = environment.stripeConstants;
  timeDifference = new TimeDelta(0, 0, 0, 0);
  timer: any;
  shouldDisplayVoters = false;
  remainingVoters: Array<ShortVoter>;
  quorum: number;
  quorumActual: string;
  shouldDisplayRelaunchWarning = false;
  isSms = false;
  is2FA = false;
  emailsSent = false;
  inviteDate = '';
  remainingTime: string;
  answers: Array<any>;
  votingType: string;
  lists = [];
  resendOngoingLoader = false;
  sharedLinks: any;
  hasAssessorsButtons = false;
  electionList: any;
  displayedAnswers: Array<Array<string>> = [];
  subjects: any;
  titles: Array<string> = [];
  maxVoters = 10;
  accountName = '';
  hasHotline: any;
  licenseTime: string;
  eventCounter = 0;
  licencesReady = false;
  isAssoc: boolean;
  clientType = 'assoc';
  rounds: Array<Round>;
  shouldChangeVoter = false;
  shouldDisplayChangeVoterValidation = false;
  showPreCloseButton = false;
  displayPreClosePopup = false;
  isDescriptionExpanded = false;
  displaySuspendPopup: Boolean = false;
  displayResumePopup: boolean = false;
  displayConfirmSuspendPopup: boolean = false;
  displayConfirmResumePopup: boolean = false;
  assessors: Array<{ name: string, email: string }> = [];
  pollImage: string;
  suspendErrorMessage: Array<string> = ['', '', ''];
  suspendActiveAssessors: Array<{ name: string, email: string }> = [];
  suspendMessage: string;
  suspended: any;
  cseParticipation: ParticipationResponse;
  colleges: Array<ReceivedCollege> = [];
  roundPartToDisplay = 1;
  partParColleges = ['0', '0', '0', '0', '0', '0'];
  collegeType = '';
  showAdminButtons = false;

  constructor(
    private router: Router,
    private apiService: ApiService,
    public common: Common,
    public route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private licenseService: LicenseService
  ) {
  }

  refreshData() {
    this.route.queryParams
      .subscribe(qParams => {
        if (qParams.resolution == null) {
          this.apiService.getParticipation(this.pollId).subscribe((partRes: ParticipationResponse) => {
            this.setupParticipation(partRes);
          });
        } else {
          const index = parseInt(qParams.resolution, 10);
          const realIndex = this.isLive && this.rounds.length >= index ? this.rounds[index].round : index;
          this.apiService.getParticipationRound(this.pollId, realIndex).subscribe((partRes: ParticipationResponse) => {
            this.setupParticipation(partRes);
          });
        }
      });
  }

  rejoinPoll() {
    this.router.navigate(['/poll-live/' + this.pollId]);
  }

  displayVoters() {
    this.apiService.getRRemaining(this.pollId).subscribe((res: VoterVotedResponse) => {
      this.remainingVoters = res.remainingVoters;
      this.shouldDisplayVoters = true;
    });
  }

  dismissVoters() {
    this.shouldDisplayVoters = false;
  }

  downloadVoterFile() {
    this.apiService.getVotersFile(this.pollId, this.common.getLangCode()).subscribe((res) => {
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
      saveAs(blob, this.common.getVotersExcelName('xlsx', this.common.getLangCode()));
    });
  }

  downloadQuorumFile() {
    this.apiService.getQuorumFile(this.pollId, this.common.getLangCode()).subscribe((res) => {
      const blob = new Blob([res], { type: 'application/pdf\n' });
      saveAs(blob, 'quorum.pdf');
    });
  }

  displayRelaunchWarning() {
    this.shouldDisplayRelaunchWarning = true;
  }

  handleRelaunch($event: boolean) {
    if (!$event) { this.shouldDisplayRelaunchWarning = false; }
    else {
      this.resendOngoingLoader = true;
      this.shouldDisplayRelaunchWarning = false;
      this.apiService.resendInvitations(this.pollId).subscribe((res) => {
        this.resendOngoingLoader = false;
        this.emailsSent = true;
        this.shouldDisplayRelaunchWarning = false;
        this.handleResend();
      }, (err: any) => {
        this.resendOngoingLoader = false;
        this.shouldDisplayRelaunchWarning = false;
        console.log(err);
      });
    }
  }

  displayPreCloseWarning() {
    this.displayPreClosePopup = true;
  }

  handlePreClose() {
    const accountName = this.authenticationService.getUserData();
    if (this.authenticationService.getSuperAdmin(accountName)) {
      this.showPreCloseButton = true;
    }
  }

  dismissForceClose(shouldClose: boolean) {
    if (shouldClose) {
      this.apiService.preCloseElection(this.pollId).subscribe((res) => {
        window.location.reload();
      });
    } else {
      this.displayPreClosePopup = false;
    }
  }

  handleResend() {
    this.apiService.canResend(this.pollId).subscribe((res) => {
    }, (err: any) => {
      this.emailsSent = true;
      if (err.status === 403) {
        this.inviteDate = new Date(err.error).toLocaleString();
        const inviteTresholdTimestamp = new Date(err.error).getTime();
        const timeDiffTimestamp = inviteTresholdTimestamp - new Date().getTime();
        const displayedHours = Math.floor(timeDiffTimestamp / 1000 / 60 / 60);
        const displayedMinutes = Math.floor((timeDiffTimestamp - (displayedHours * 1000 * 60 * 60)) / 1000 / 60);
        const displayedHrString = displayedHours > 9 ? displayedHours.toString() : '0' + displayedHours;
        const displayedMinString = displayedMinutes > 9 ? displayedMinutes.toString() : '0' + displayedMinutes;
        this.remainingTime = `${displayedHrString}h${displayedMinString}m`;
      }
      if (err.status === 410) {
        this.remainingTime = null;
      }
    });
  }

  editPoll() {
    this.router
      .navigateByUrl('/vc-poll-edition', { skipLocationChange: true })
      .then(() => {
        this.router.navigate(['poll-creation/' + this.pollId]);
      });
  }

  electionToListData() {
    // Match subject from the first index of this.answers to the lists from following indexes
    this.electionList.forEach(rounds => {

      rounds.displayedQuestions.forEach((element, index) => {

        if (element.parent === this.displayedAnswers.length && rounds.displayedQuestions.length - 1 !== index) {
          this.displayedAnswers[element.parent] = [];
        }

        if (rounds.displayedQuestions.length - 1 !== index) {
          index === 0 ? this.subjects = element.answers : this.displayedAnswers[element.parent].push(element.question);
        }
      });
    });
  }

  changeVoter() {
    this.shouldChangeVoter = true;
  }

  setupParticipation(partRes: ParticipationResponse) {
    if (partRes.votes != null) {
      this.votes = partRes.votes;
    }
    this.percentage = (this.votes / this.votersCount) * 100;
    if (this.percentage === 100) {
      this.percentageString = this.percentage.toPrecision(3);
    }
    else {
      this.percentageString = this.percentage.toFixed(2);
    }
    this.cseParticipation = partRes;
    this.quorumActual = partRes.quorum.toString();
  }

  getTitularPercentage() {
    if (this.cseParticipation != null) {
      const allTitularVotes = this.cseParticipation.allTitularVotes != null ? this.cseParticipation.allTitularVotes : 0;
      const allTitularVoters = this.cseParticipation.allTitularVoters != null ? this.cseParticipation.allTitularVoters : 0;
      if (allTitularVoters === 0) { return '0'; }
      else {
        return (allTitularVotes / allTitularVoters * 100).toFixed(2);
      }
    }
    return '0';
  }

  getSupplementaryPercentage() {
    if (this.cseParticipation != null) {
      const supplementaryVotes = this.cseParticipation.supplementaryVotes != null ? this.cseParticipation.supplementaryVotes : 0;
      const supplementaryVoters = this.cseParticipation.supplementaryVoters != null ? this.cseParticipation.supplementaryVoters : 0;
      if (supplementaryVoters === 0) {
        return '0';
      } else {
        return (supplementaryVotes / supplementaryVoters * 100).toFixed(2);
      }
    }
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.pollId = params.get('id');
      this.handleResend();
      this.apiService.getPollData(this.pollId).subscribe((res: any) => {
        this.votingType = res.type;
        this.isOpen = res.opened;
        this.title = res.name;
        this.pollImage = res.image;
        this.lists = res.rounds;
        res.rounds.forEach(element => {
          this.titles.push(element.title);
        });
        this.suspended = res.suspended;
        this.isLive = res.isLive;
        this.votersCount = res.nbVoters;
        this.description = res.description;
        this.startDate = this.startDate + new Date(res.startDate).toLocaleString();
        this.endDate = this.isLive ? '-' : this.endDate + new Date(res.endDate).toLocaleString();
        this.isPublic = res.publicVote;
        this.isSms = res.smsOption;
        this.is2FA = res.is2FA;
        this.showAdminButtons = res.isCreator;
        this.hasAssessorsButtons = res.assessors > 0;
        this.sharedLinks = res.sharedLinks;
        this.rounds = res.rounds;
        this.quorum = res.quorum;
        this.colleges = res.colleges;
        if (this.colleges.length > 0) {
          this.selectCollege(1);
          // this.selectCollege(parseInt(this.colleges[0].college, 10));
        }
        if (this.votingType.localeCompare('resolution') === 0) {
          this.answers = res.rounds.flatMap(r => r.displayedQuestions);
        } else {
          this.electionList = res.rounds;
          if (res.rounds[0].displayedQuestions.length > 0) {
            this.answers = res.rounds;
            if (this.answers.length > 0) { this.candidates = this.answers[0].displayedQuestions; }
          }
        }
        if ((res.type === 'resolution' || res.type === 'live') && this.isLive) {
          this.answers = res.rounds.flatMap(el => el.displayedQuestions);
          this.resolutions = this.answers.map(v => v.question);
          const timeDiff = (new Date(res.endDate)).getTime() - (new Date()).getTime();
          this.timeDifference = this.common.getTimeDelta(timeDiff);
        }
        this.timer = setInterval(() => {
          const timeDiff = (new Date(res.endDate)).getTime() - (new Date()).getTime();
          if (timeDiff < 0) {
            this.router.navigateByUrl('/poll-result?poll=' + this.pollId);
          }
          this.timeDifference = this.common.getTimeDelta(timeDiff);
        }, 1000);
        this.route.queryParams
          .subscribe(qParams => {
            if (qParams.resolution == null) {
              this.apiService.getParticipation(this.pollId).subscribe((partRes: ParticipationResponse) => {
                this.setupParticipation(partRes);
              });
            } else {
              const index = parseInt(qParams.resolution, 10);
              const realIndex = this.isLive && res.rounds.length > index ? res.rounds[index].round : index;
              this.apiService.getParticipationRound(this.pollId, realIndex).subscribe((partRes: ParticipationResponse) => {
                this.setupParticipation(partRes);
              });
            }
          });
        if (this.votingType === 'list') { this.electionToListData(); }
        this.handlePreClose();
      }, (err: any) => {
        this.isError = true;
        this.errorMessage = 'Nous sommes désolés mais vous ne pouvez accéder au contenu \
            erreur ' + err.status;
      });
    });

    this.apiService.getAssessors(this.pollId).subscribe((res: any) => {
      res.map((assessor) => {
        const itm = {
          name: assessor.split('-')[0].trim(),
          email: assessor.split('-')[1].trim()
        };
        this.assessors.push(itm);
      });
    });
    this.stripe = Stripe(this.stripeConstants.key);

    this.licenseService.license.subscribe((res: LicenseData) => {
      this.licencesReady = true;
      this.hasHotline = res.hasHotline;
      this.maxVoters = res.votes;
      this.eventCounter = res.events;
      if (res.client !== null) { this.isAssoc = !(res.client !== 'corp'); }
      this.clientType = res.client;
      this.licenseTime = this.common.licenseResponseGetTime(res);
      this.accountName = this.authenticationService.getUserData();
    });
  }

  closeChangeVoter(event: boolean) {
    this.shouldChangeVoter = false;

    if (event) { this.shouldDisplayChangeVoterValidation = true; }
  }

  closeChangeValidation() {
    this.shouldDisplayChangeVoterValidation = false;
  }

  startAudit() {
    this.apiService.startAuditOrganizer(this.pollId).subscribe((res) => { });
  }

  getAudits() {
    this.apiService.getAudits(this.pollId).subscribe((res: Array<Checkup>) => {
      console.log(res);
    });
    this.apiService.getLogs(this.pollId).subscribe((res: Array<Checkup>) => {
      console.log(res);
    });
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }


  getTruncatedDescription(): string {
    if (!this.description) {
      return '';
    }
    if (this.description.length <= 100) {
      return this.description;
    }
    return this.description.substring(0, 100) + '...';
  }

  toggleDescription(): void {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  triggerSuspendPopup() {
    this.displaySuspendPopup = true;
    this.getSuspendedAssessorStatus()
  }

  triggerResumePopup() {
    this.displayResumePopup = true;
    this.getSuspendedAssessorStatus()
  }

  handleSuspendMessage($event: string) {
    this.suspendMessage = $event;
  }

  handleConfirmSuspend($event: boolean) {
    this.displayConfirmSuspendPopup = false;
  }

  handleConfirmResume($event: boolean) {
    this.displayConfirmResumePopup = false;
  }

  handleSuspend($event: boolean) {
    if (!$event) {
      this.suspendMessage = "";
      this.displaySuspendPopup = false;
    }
    else {
      this.apiService.suspendPoll(this.pollId, this.suspendMessage).subscribe((res) => {
        // window.location.reload();
        this.displayConfirmSuspendPopup = true;
        this.suspended = true
      }, (err: any) => {
        console.error("Error suspending election: ", err);
      });

      this.displaySuspendPopup = false;
    }
  }

  selectCollege($event: number) {
    this.roundPartToDisplay = $event;
    const selRounds = this.rounds.filter((p) => p.college === $event);
    const selTitRound = selRounds.filter((p) => p.mainElection === true);
    if (selTitRound.length > 0) {
      this.partParColleges[0] = selTitRound[0].votes.toString();
      this.partParColleges[1] = selTitRound[0].voters.toString();
      this.partParColleges[2] = (selTitRound[0].votes / selTitRound[0].voters * 100).toFixed(2);
    } else {
      this.partParColleges[0] = '0';
      this.partParColleges[1] = '0';
      this.partParColleges[2] = '0';
    }
    const selSupRound = selRounds.filter((p) => p.mainElection === false);
    if (selSupRound.length > 0) {
      this.partParColleges[3] = selSupRound[0].votes.toString();
      this.partParColleges[4] = selSupRound[0].voters.toString();
      this.partParColleges[5] = (selSupRound[0].votes / selSupRound[0].voters * 100).toFixed(2);
    } else {
      this.partParColleges[3] = '0';
      this.partParColleges[4] = '0';
      this.partParColleges[5] = '0';
    }
    this.collegeType = this.getCollegeContentString();
  }

  getCollegeContentString() {
    //const college = this.colleges.filter(c => c.college === this.roundPartToDisplay.toString());
    const college = this.colleges[this.roundPartToDisplay - 1];
    // if (college.length > 0) {
      return college.content;
    // } else { return ''; }
  }

  handleResume($event: boolean) {
    if (!$event) {
      this.displayResumePopup = false;
    }
    else {
      this.apiService.suspendPoll(this.pollId, "").subscribe((res) => {
        this.displayConfirmResumePopup = true;
        this.suspended = false
      }, (err: any) => {
        console.error("Error suspending election: ", err);
      });
      this.displayResumePopup = false;
    }
  }

  getSuspendedAssessorStatus() {

    this.apiService.getSuspendedAssessorStatus(this.pollId).subscribe((res: SuspendAssessor) => {
      this.suspendActiveAssessors = res.activeAssessors;
    }, (err: any) => {
      console.error("Error getting Suspended Assessor Status: ", err);
    });
  }

  handleSuspendAssessorKey($event) {
    const body = {
      email: $event.email,
      code: $event.code
    };
    this.suspendErrorMessage[$event.index] = '';
    this.apiService.sendSuspendAssessorKey(this.pollId, body).subscribe((res: SuspendAssessor) => {
      this.suspendActiveAssessors = res.activeAssessors;
    }, (err: any) => {
      this.suspendErrorMessage[$event.index] = 'Cléf non valide';
    });
  }
}
